import * as React from "react";
const SvgEditConvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15px"
    height="15px"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g
      stroke="#3D3D3D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M14.48 20.444h7.252" />
      <path
        d="M13.512 3.795a2.245 2.245 0 0 1 3.116-.303l1.733 1.347a2.14 2.14 0 0 1 .72 2.984c-.034.054-9.537 11.942-9.537 11.942a1.7 1.7 0 0 1-1.31.632l-3.639.046-.82-3.47c-.115-.489 0-1.001.316-1.396z"
        clipRule="evenodd"
      />
      <path d="m11.753 6 5.452 4.187" />
    </g>
  </svg>
);
export default SvgEditConvgIcon;
